import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SuccessResponse } from 'src/app/common/models/SuccessRespons';
import { environment as env } from 'src/environments/environment';
import { LocalStorageService } from 'src/app/common/services/local-storage.service';
import { PolicyCancelResponse } from 'src/app/common/models';
import { Api, ApigatewayService } from 'src/app/common/services/apigateway.service';
import { ProposalRequest } from '../../help-desk/model/ProposalRequest';
import { InsuranceDataResponse } from '../../steps/step-checkout/models/InsuranceDataResponse.interface';

@Injectable({ providedIn: 'root' })
export class ProposalService {
  COUNTRY = env.COUNTRY;

  private directUrl =
    'https://psyrzshlo7.execute-api.us-west-2.amazonaws.com/artico-pe-dev-api/api-artico';

  constructor(
    private httpClient: HttpClient,
    private localStorageService: LocalStorageService,
    private apigatewayService: ApigatewayService
  ) {}

  // private bestApi = this.apigatewayService.getBestApiGateway();

  // private ARTICO_BASE_URL = `${this.bestApi}${env.ARTICO_API_BASE_URL}/api/v1`;
  private ARTICO_BASE_URL = `${this.apigatewayService.getApiUrl(Api.ARTICO)}/api/v1`;

  // private PROPOSALS_BASE_URL = `${this.bestApi}${this.ARTICO_BASE_URL}/artico/proposal`;
  private PROPOSALS_BASE_URL = `${this.apigatewayService.getApiUrl(Api.ARTICO)}/artico/proposal`;


  findAll(data: ProposalRequest) {
    const params = new HttpParams()
      .set('codEmpresa', data.codEmpresa)
      .set('offset', data.offset)
      .set('limit', data.limit)
      .set('sort', data.sort)
      .set('filter', data.filter);
    const URL = `${this.ARTICO_BASE_URL}/web/modular/${this.COUNTRY}/proposals/list`;
    const token = this.localStorageService.get('sessionToken');
    const header = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    const options = { header, params };
    return this.httpClient.get<SuccessResponse>(URL, options);
  }

  save(data: any) {
    const URL = this.PROPOSALS_BASE_URL;
    return this.httpClient.post<SuccessResponse>(URL, data);
  }

  update(data: any, id: string) {
    const URL = `${this.PROPOSALS_BASE_URL}/${id}`;
    return this.httpClient.put<SuccessResponse>(URL, data);
  }

  get(id: string) {
    const URL = `${this.ARTICO_BASE_URL}/web/modular/${this.COUNTRY}/proposals/findAll/${id}`;
    return this.httpClient.get<SuccessResponse>(URL);
  }

  remove(data: any, id: string) {
    const URL = `${this.PROPOSALS_BASE_URL}/remove/${id}`;
    return this.httpClient.put<SuccessResponse>(URL, data);
  }

  downloadProposal(proposalNumber: string) {
    const URL = `${this.ARTICO_BASE_URL}/web/modular/pe/proposal/export/pdf/${proposalNumber}?codEmpresa=PE`;
    return this.httpClient.get<SuccessResponse>(URL);
  }

  createAplication(data: any) {
    const URL = `${this.ARTICO_BASE_URL}/web/modular/${this.COUNTRY}/application/create?codEmpresa=PE`;
    return this.httpClient.post<SuccessResponse>(URL, data);
  }

  updateAplication(data: any, codigo: any, proposalNumber: any) {
    const headers = this.getHeader();
    const URL = `${this.ARTICO_BASE_URL}/web/modular/${this.COUNTRY}/application/update/${proposalNumber}?codEmpresa=${codigo}`;
    return this.httpClient.put<SuccessResponse>(URL, data, { headers });
  }

  updateProposal(data: any, codigo: any, proposalNumber: any) {
    const headers = this.getHeader();
    const URL = `${this.ARTICO_BASE_URL}/web/modular/${this.COUNTRY}/proposal/update/${proposalNumber}?codEmpresa=${codigo}`;
    return this.httpClient.put<SuccessResponse>(URL, data, { headers });
  }

  presignExtraFiles(data: any, codigo: any) {
    const URL = `${this.ARTICO_BASE_URL}/web/modular/${this.COUNTRY}/document/presignurl?codEmpresa=${codigo}`;
    return this.httpClient.post<any>(URL, data);
  }

  sendFiles(data: any, codigo: any) {
    const URL = `${this.ARTICO_BASE_URL}/web/modular/${this.COUNTRY}/document/upload?codEmpresa=${codigo}`;
    return this.httpClient.post<any>(URL, data);
  }

  getSections(codEmpresa: string, id: string) {
    const URL = `${this.ARTICO_BASE_URL}/journey/sections/${id}?codEmpresa=${codEmpresa}`;
    return this.httpClient.get<Array<any>>(URL);
  }

  private getHeader(): HttpHeaders {
    const token = this.localStorageService.get('sessionToken');
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return headers;
  }

  getDubai(proposalNumber: string, codEmpresa: string) {
    const URL = `${this.ARTICO_BASE_URL}/web/modular/${this.COUNTRY}/dubai/export/pdf/${proposalNumber}?codEmpresa=${codEmpresa}`;
    return this.httpClient.get<SuccessResponse>(URL);
  }

  getPremiumAndRates(proposalCode: string) {
    const URL = `${
      this.ARTICO_BASE_URL
    }/journey/premium/${proposalCode}?codEmpresa=${this.COUNTRY.toUpperCase()}`;
    return this.httpClient.get<InsuranceDataResponse>(URL);
  }

  getProposalData(proposalNumber: string, codEmpresa: string) {
    const URL = `${this.ARTICO_BASE_URL}/web/modular/${this.COUNTRY}/proposals/find/${proposalNumber}?codEmpresa=${codEmpresa}`;
    return this.httpClient.get<SuccessResponse>(URL);
  }

  aplicationToProposal(data: any) {
    const headers = this.getHeader();
    const URL = `${this.ARTICO_BASE_URL}/web/modular/pe/proposal/emit?codEmpresa=PE`;
    return this.httpClient.post<SuccessResponse>(URL, data, { headers });
  }

  proposalToPolicy(data: any) {
    const headers = this.getHeader();
    const URL = `${this.ARTICO_BASE_URL}/web/modular/pe/policy/emit?codEmpresa=PE`;
    return this.httpClient.post<SuccessResponse>(URL, data, { headers });
  }

  getProposalFiles(proposalNumber: string, codEmpresa: string) {
    const URL = `${this.ARTICO_BASE_URL}/journey/documents/${proposalNumber}?codEmpresa=${codEmpresa}`;
    return this.httpClient.get<SuccessResponse>(URL);
  }

  checkPipedrive(pipedrive: string, codEmpresa: string) {
    const URL = `${this.ARTICO_BASE_URL}/journey/pipedrive/${pipedrive}?codEmpresa=${codEmpresa}`;
    return this.httpClient.get<SuccessResponse>(URL);
  }

  deleteProposalOrApplication(policyNumber: string) {
    const headers = this.getHeader();
    const URL = `${this.ARTICO_BASE_URL}/web/modular/pe/application/reject/${policyNumber}?codEmpresa=PE`;
    return this.httpClient.put<SuccessResponse>(URL, null, { headers });
  }

  precalculateCancellation(policyNumber: string, cancellationDate: string) {
    const apiUrl = `${this.ARTICO_BASE_URL}/web/property/br/endorsement/precalculate-cancellation/${policyNumber}/${cancellationDate}?codEmpresa=BR`;
    return this.httpClient.get<PolicyCancelResponse>(apiUrl);
  }

  cancelPolicy(data: any) {
    const apiUrl = `${this.ARTICO_BASE_URL}/web/property/br/endorsement/proposal?codEmpresa=BR`;
    return this.httpClient.post<SuccessResponse>(apiUrl, data);
  }

  getEndoConfirm(policyNumber: string, endorsementNumber: string, obj: any) {
    const apiUrl = `${this.ARTICO_BASE_URL}/web/property/br/endorsement/export/confirm/pdf/${policyNumber}/${endorsementNumber}?codEmpresa=BR`;
    return this.httpClient.get<SuccessResponse>(apiUrl, obj);
  }

  getEndoProposal(proposalNumber: string, endorsementNumber: string) {
    const apiUrl = `${this.ARTICO_BASE_URL}/web/property/br/endorsement/export/proposal/pdf/${proposalNumber}/${endorsementNumber}?codEmpresa=BR`;
    return this.httpClient.get<SuccessResponse>(apiUrl);
  }

  getParametersQuotes(name: string, codEmpresa: string) {
    const apiUrl = `${this.ARTICO_BASE_URL}/configurations/parameter/${name}?codEmpresa=${codEmpresa}`;
    return this.httpClient.get<SuccessResponse>(apiUrl);
  }
}
